import Column from '@app/components/layout/Column'
import { Card } from '@app/components/blocks/card/Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faHouseMedical,
  faElevator,
  faDumbbell,
  faStar,
  type IconDefinition,
  faTreeDeciduous,
  faPersonSwimming,
  faWheelchair,
  faScrewdriverWrench,
  faUtensils,
  faTeddyBear,
} from '@fortawesome/pro-regular-svg-icons'
import { Text } from '@app/components/core/typography/Text'

const AMENITY_ICON_MAP: Record<string, IconDefinition> = {
  'house-medical': faHouseMedical,
  dumbbell: faDumbbell,
  'tree-deciduous': faTreeDeciduous,
  'person-swimming': faPersonSwimming,
  wheelchair: faWheelchair,
  elevator: faElevator,
  'screwdriver-wrench': faScrewdriverWrench,
  utensils: faUtensils,
  'teddy-bear': faTeddyBear,
  star: faStar,
} as const

const DEFAULT_AMENITY_ICON = faStar

export const AmenityCard = ({
  label,
  iconName,
  selected,
  onClick,
}: {
  label: string
  iconName?: string | null
  selected: boolean
  onClick: () => void
}) => {
  const icon =
    iconName?.trim() && AMENITY_ICON_MAP[iconName]
      ? AMENITY_ICON_MAP[iconName]
      : DEFAULT_AMENITY_ICON
  return (
    <Card
      onClick={onClick}
      style={{
        borderRadius: '0.9375rem',
        border: `1px solid ${selected ? 'var(--primary-blue)' : 'var(--shades-blue-50)'}`,
        width: '6.875rem',
        height: '6.875rem',
      }}
      contentStyle={{
        padding: '1rem 0.5rem',
      }}
    >
      <Column gap={'0.5rem'} alignItems="center">
        <FontAwesomeIcon
          icon={icon}
          style={{
            height: '2rem',
            width: '2rem',
          }}
        />
        <Text.Small
          style={{
            color: selected ? 'var(--primary-blue)' : 'var(--shades-blue-500)',
            textAlign: 'center',
            wordBreak: 'break-all',
          }}
        >
          {label}
        </Text.Small>
      </Column>
    </Card>
  )
}
